import '../styling/global.css';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import websiteLogo from '../assets/JSKM Logo.webp';

const servicesData = [
  {
    id: 1,
    title: 'AI & Data Services',
    subItems: [
      { name: 'Internet & Web Research Services', slug: 'internet-web-research-services' },
      { name: 'Sentiment Analysis', slug: 'sentiment-analysis' },
      { name: 'Search Relevance', slug: 'search-relevance' },
      { name: 'Search Data Testing', slug: 'search-data-testing' },
      { name: 'Product Data Management', slug: 'product-data-management' },
      { name: 'Store Checks', slug: 'store-checks' },
      { name: 'Mystery Checks', slug: 'mystery-checks' },
      { name: 'Surveys', slug: 'surveys' }
    ]
  },
  {
    id: 2,
    title: 'Data Annotation & Dataset Solutions',
    subItems: [
      { name: 'Categorization & Tagging', slug: 'categorization-tagging' },
      { name: 'Product Categorization & Tagging', slug: 'product-categorization-tagging' },
      { name: 'Image & Video Tagging', slug: 'image-video-tagging' },
      { name: 'Video Analysis', slug: 'video-analysis' },
      { name: 'Image Annotation', slug: 'image-annotation' },
      { name: 'Human in the Loop Services', slug: 'human-in-the-loop-services' },
      { name: 'AI Content Editing & Creation', slug: 'ai-content-editing-creation' }
    ]
  },
  {
    id: 3,
    title: 'AI Training Dataset Development',
    subItems: [
      { name: 'AI Datasets for ML', slug: 'ai-datasets-for-ml' },
      { name: 'Audio & Voice Datasets', slug: 'audio-voice-datasets' },
      { name: 'LLM Dataset Services', slug: 'llm-dataset-services' },
      { name: 'Image & Photo Datasets', slug: 'image-photo-datasets' },
      { name: 'Face Recognition Training Data', slug: 'face-recognition-training-data' },
      { name: 'Video Datasets', slug: 'video-datasets' }
    ]
  },
  {
    id: 4,
    title: 'Testing & Quality Assurance',
    subItems: [
      { name: 'Mobile App Testing', slug: 'mobile-app-testing' },
      { name: 'Store Checks (QA field audits)', slug: 'store-checks-qa-field-audits' },
      { name: 'Search Data Test', slug: 'search-data-test' },
      { name: 'Mystery Checks (Customer experience QA)', slug: 'mystery-checks-customer-experience-qa' }
    ]
  },
  {
    id: 5,
    title: 'App & Web Development',
    subItems: [
      { name: 'Mobile App Development (iOS & Android)', slug: 'mobile-app-development-ios-android' },
      { name: 'Website Development', slug: 'website-development' },
      { name: 'Web App UI/UX Design', slug: 'web-app-ui-ux-design' },
      { name: 'Template Design', slug: 'template-design' }
    ]
  },
  {
    id: 6,
    title: 'Creative & Graphic Design Services',
    subItems: [
      { name: 'Logo Design', slug: 'logo-design' },
      { name: 'Website and App Design', slug: 'website-and-app-design' },
      { name: 'Social Media Graphics', slug: 'social-media-graphics' },
      { name: 'Print Materials Design', slug: 'print-materials-design' },
      { name: 'Presentation Design', slug: 'presentation-design' },
      { name: 'Brand Kit Development', slug: 'brand-kit-development' },
      { name: 'Marketing Materials Design', slug: 'marketing-materials-design' },
      { name: 'Video and Image Editing', slug: 'video-and-image-editing' }
    ]
  }
];

const Header = () => {
  const [hoveredServiceIndex, setHoveredServiceIndex] = useState(null);
  const [isServicesHovered, setIsServicesHovered] = useState(false);
  const [isProductsHovered, setIsProductsHovered] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 1024);
  const [loginLink, setLoginLink] = useState({ to: '/login', label: 'Login' });

  // ✅ Function to update the login link based on localStorage
  const updateLoginLink = () => {
    const loginType = localStorage.getItem('role'); // make sure you're using 'loginType'
    if (loginType === 'Admin') {
      setLoginLink({ to: '/admin-dashboard', label: 'Admin Dashboard' });
    } else if (loginType === 'Employee') {
      setLoginLink({ to: '/employee-dashboard', label: 'Employee Dashboard' });
    } else {
      setLoginLink({ to: '/login', label: 'Login' });
    }
  };

  useEffect(() => {
    updateLoginLink();

    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 1024);
      if (window.innerWidth > 1024) setIsMobileMenuOpen(false);
    };

    window.addEventListener('resize', handleResize);

    // ✅ Listen for any localStorage changes (across tabs)
    const handleStorageChange = () => updateLoginLink();
    window.addEventListener('storage', handleStorageChange);

    // ✅ Listen for custom event trigger from same tab
    const handleCustomChange = () => updateLoginLink();
    window.addEventListener('roleChanged', handleCustomChange);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('loginTypeChanged', handleCustomChange);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="site-header">
      <div className="header-container">
        <nav>
          <Link to="/" onClick={closeMobileMenu}>
            <img
              src={websiteLogo}
              alt="Website Logo"
              className="logo-image"
            />
          </Link>

          {isMobileView ? (
            <div className="mobile-menu-wrapper">
              <button
                className={`hamburger-menu ${isMobileMenuOpen ? 'open' : ''}`}
                onClick={toggleMobileMenu}
                aria-label="Toggle menu"
              >
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
              </button>

              <div className={`mobile-menu-overlay ${isMobileMenuOpen ? 'open' : ''}`}>
                <ul className="mobile-nav-list">
                  <li><Link to="/" className="mobile-nav-link" onClick={closeMobileMenu}>Home</Link></li>
                  <li><Link to="/about-us" className="mobile-nav-link" onClick={closeMobileMenu}>About Us</Link></li>
                  <li><Link to="/services" className="mobile-nav-link" onClick={closeMobileMenu}>Services</Link></li>
                  <li><Link to="/products" className="mobile-nav-link" onClick={closeMobileMenu}>Products</Link></li>
                  <li><Link to="/importsexports" className="mobile-nav-link" onClick={closeMobileMenu}>Imports/Exports</Link></li>
                  <li><Link to="/careers" className="mobile-nav-link" onClick={closeMobileMenu}>Careers</Link></li>
                  <li><Link to="/contact-us" className="mobile-nav-link" onClick={closeMobileMenu}>Contact Us</Link></li>
                  <li><Link to={loginLink.to} className="mobile-nav-link" onClick={closeMobileMenu}>{loginLink.label}</Link></li>
                </ul>
              </div>
            </div>
          ) : (
            <ul className="nav-list">
              <li><Link to="/" className="nav-link">Home</Link></li>
              <li><Link to="/about-us" className="nav-link">About Us</Link></li>

              <li
                className="services-menu-item"
                onMouseEnter={() => setIsServicesHovered(true)}
                onMouseLeave={() => {
                  setIsServicesHovered(false);
                  setHoveredServiceIndex(null);
                }}
              >
                <Link to="/services" className="nav-link">Services</Link>
                {isServicesHovered && (
                  <div className="services-dropdown">
                    <ul className="services-list">
                      {servicesData.slice(0, 6).map((service, index) => (
                        <li
                          key={service.id}
                          className={`service-item ${hoveredServiceIndex === index ? 'active' : ''}`}
                          onMouseEnter={() => setHoveredServiceIndex(index)}
                          onMouseLeave={() => setHoveredServiceIndex(null)}
                        >
                          <Link
                            to={`/services/section/${service.id}`}
                            className="service-link"
                            onClick={() => {
                              setIsServicesHovered(false);
                              setHoveredServiceIndex(null);
                            }}
                          >
                            {service.title}
                          </Link>

                          {hoveredServiceIndex === index && (
                            <ul className="subservices-list">
                              {service.subItems.map((item, idx) => (
                                <li
                                  key={idx}
                                  className="subservice-item"
                                >
                                  <Link
                                    to={`/services/section/${service.id}#${item.slug}`}
                                    className="subservice-link"
                                    onClick={() => {
                                      setIsServicesHovered(false);
                                      setHoveredServiceIndex(null);
                                    }}
                                  >
                                    {item.name}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>

              <li
                className="products-menu-item"
                onMouseEnter={() => setIsProductsHovered(true)}
                onMouseLeave={() => setIsProductsHovered(false)}
              >
                <Link to="/products" className="nav-link">Products</Link>
                {isProductsHovered && (
                  <ul className="product-submenu">
                    <li className="submenu-item">
                      <Link to="/product-wedoo" className="product-submenu-link">Wedoo</Link>
                    </li>
                    <li className="submenu-item">
                      <Link to="/product-trustmee" className="product-submenu-link">Trustmee</Link>
                    </li>
                  </ul>
                )}
              </li>
              <li><Link to="/importsexports" className="nav-link">Imports/Exports</Link></li>
              <li><Link to="/careers" className="nav-link">Careers</Link></li>
              <li><Link to="/contact-us" className="nav-link">Contact Us</Link></li>
              {/* 👇 Dynamic Login Link based on localStorage */}
              <li><Link to={loginLink.to} className="nav-link">{loginLink.label}</Link></li>
            </ul>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;